<template lang="pug">
  transition
    .answers(
        v-if = "$store.state.isShownAnsweredArea"
      )
      img.answers__balloon.sp(
        src = "~@/assets/img/text_everyone.svg"
        alt = "みんなのアンサー"
        )
      img.answers__balloon.pc(
        src = "~@/assets/img/text_everyone_pc.svg"
        alt = "みんなのアンサー"
        )
      a.answers__hashtag(
        :href = "hashtagHref()"
        target = "_blank"
        )
        |# {{hashtagName}}
      .answers__list
        Answer(
          v-for = "tweet in tweets"
          :key = "tweet.link_url"
          :tweet = "tweet"
          )
      .answers__more
        a.answers__more-btn(
          :href = "hashtagHref()"
          target = '_blank'
          )
          .answers__more-btn-in
            IconTweet.answers__more-icon
            |もっとアンサーを見る
</template>

<script>
import questions from '@/const/questions';
import lastAnswers from '@/const/lastAnswers';
import Answer from '@/components/atoms/Answer';
import IconTweet from '@/components/atoms/IconTweet'
import { VueJsonp } from '@/mixins/vue-jsonp';
import { differenceInSeconds } from 'date-fns';
import { sleep } from '@/mixins/common';

export default {
  name: 'Answers',
  data: function() {
    return {
      currentId: 1,
      hashtag: '',
      tweets: [],
      today: new Date(),
      lastDate: new Date(2020, 2, 17, 0, 0),
    };
  },
  props: [
    'isExpired',
  ],
  components: {
    Answer,
    IconTweet
  },
  mounted() {
    let id = '';
    this.getAnswers();
    this.$store.subscribe((mutation, state) => {
      if(mutation.type === 'setCurrentQuestionId' || mutation.type === 'addAnsweredId') {
        id = mutation.payload;
        this.getAnswers(id);
      }
    })
  },
  methods: {
    getAnswers: async function(id) {
      await sleep(100);
      const { currentQuestionId } = this.$store.state;
      let cantsukuId = '';
      let url = '';
      let callbackName = '';

      if(currentQuestionId) {
        cantsukuId = questions[currentQuestionId - 1].cantsuku_id;
      }
      if(id) {
        cantsukuId = questions[id - 1].cantsuku_id;
      }
      if(isNaN(cantsukuId)) {
        cantsukuId = '';
      }
      
      if(differenceInSeconds(this.today, this.lastDate) > 0) {
        this.tweets = lastAnswers;
      } else {
        if(this.$store.state.answeredIds.length >= 24 && !this.$store.state.isAnswered) {
          url = 'https://cam-cloudtools.com/widget/vitality_himekuri/jsonp/item_twitter.jsonp';
          callbackName = 'getTweetJsonp_vitality_himekuri_twitter';
        } else {
          url = `https://cam-cloudtools.com/widget/vitality_himekuri${cantsukuId}/jsonp/item_twitter.jsonp`;
          callbackName = `getTweetJsonp_vitality_himekuri${cantsukuId}_twitter`;
          url = url.replace(/\s+/g, '');
          callbackName = callbackName.replace(/\s+/g, '');
        }
        this.$jsonp(
          url,
          {
            callbackName: callbackName
          }
        ).then(json => {
          this.tweets = json.data.slice(0, 15);
        }).catch(err => {
          // Failed.
        })
      }
    },
    hashtagHref: function() {
      return `https://twitter.com/hashtag/${encodeURIComponent(this.hashtagName)}`
    }
  },
  computed: {
    hashtagName: function() {
      const { currentQuestionId, answeredIds } = this.$store.state;
      if(differenceInSeconds(this.today, this.lastDate) > 0 || (this.$store.state.answeredIds.length >= 24 && !this.$store.state.isAnswered)) {
        return '日めくりクエスチョン';
      } else {
        return questions[currentQuestionId - 1].hash1;
      }
    },
  },
  watch: {
    isExpired() {
      this.today = new Date(2020, 2, 17, 0, 1);
      if (differenceInSeconds(this.today, this.lastDate) > 0) {
        this.$jsonp(
          'https://cam-cloudtools.com/widget/vitality_himekuri/jsonp/item_twitter.jsonp',
          {
            callbackName: 'getTweetJsonp_vitality_himekuri_twitter'
          }
        ).then(json => {
          this.tweets = json.data.slice(0, 15);
        }).catch(err => {
          // Failed.
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .answers {
    position: relative;
    box-sizing: border-box;
    @include l-more-than-mobile {
      margin-top: 36px;
      padding-top: 26px;
      background: $primary-color;
    }
    @include l-mobile {
      margin-top: 45px;
      margin-left: 3px;
      margin-right: 3px;
      padding-top: 26px;
      background: $base-color;
    }
    &__balloon {
      display: block;
      position: absolute;
      top: -35px;
      left: 0;
      right: 0;
      margin-top: 0;
      margin-left: auto;
      margin-right: auto;
      &.pc {
        @include l-mobile {
          display: none;
        }
      }
      &.sp {
        @include l-more-than-mobile {
          display: none;
        }
      }
    }
    &__hashtag {
      display: block;
      text-align: center;
      @include fontSizeAll(24, 20);
      font-weight: bold;
      @include l-more-than-mobile {
        margin-top: 15px;
        margin-bottom: 20px;
        color: $base-color;
        text-decoration: none;
      }
      @include l-mobile {
        margin-top: 20px;
        margin-bottom: 16px;
        color: $primary-color;
        text-decoration: underline;
      }
    }
    &__list {
      overflow-y: scroll;
      :first-of-type {
        @include l-more-than-mobile {
          border-top: none;
        }
      }
      @include l-more-than-mobile {
        width: 1000px;
        height: 354px;
        background: $base-color;
        margin-left: auto;
        margin-right: auto;
        border-radius: 10px;
      }
      @include l-mobile {
        height: 60vh;
      }
    }
    &__more {
      @include l-more-than-mobile {
        padding-top: 20px;
        padding-bottom: 20px;
      }
      @include l-mobile {
        padding-top: 15px;
        padding-bottom: 15px;
        border-top: 1px solid $primary-color-pale;
      }
    }
    &__more-btn {
      display: block;
      height: 55px;
      width: 275px;
      box-sizing: border-box;
      cursor: pointer;
      padding-bottom: 4px;
      margin: auto;
      border-radius: 28px;
      @include fontSize(18);
      font-weight: bold;
      color: #fff;
      background-color: $color-twitter;
      text-decoration: none;
      &-in {
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }
    &__more-icon {
      margin-top: 2px;
      margin-right: 12px;
    }
  }
  .v-enter-active, .v-leave-active {
    transition: opacity .3s, transform .5s;
  }
  .v-enter, .v-leave-to {
    opacity: 0;
    transform-origin: bottom;
    @include l-more-than-mobile {
      transform: translateY(30px);
    }
    @include l-mobile {
      transform: translateY(5%);
    }
  }
</style>
